"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportConfiguration = exportConfiguration;
const shared_1 = require("../../../../backend/features/configurable-lists/shared");
const shared_2 = require("../../../../backend/features/editable-pages/shared");
const shared_3 = require("../../../../backend/features/editable-settings/shared");
function exportConfiguration({ t, features, classifiers, progressCallback, getFunctionClient, getStorageClient, }) {
    let status = 'counting';
    let total = 0;
    let count = 0;
    const cancelRef = { cancel: false };
    const result = {};
    progressCallback({ status, total, count });
    (async function () {
        if (features.includes('editable-settings')) {
            total += (await getFunctionClient().executeFunction({
                functionName: 'getSettingsByGroup',
                params: { filter: [{ column: 'readOnly', op: '=', value: false }], limit: 0 },
            })).result.total;
            if (cancelRef.cancel) {
                return;
            }
        }
        if (features.includes('editable-pages')) {
            total += await getStorageClient(shared_2.editablePageEntityName).count({});
            if (cancelRef.cancel) {
                return;
            }
        }
        if (features.includes('configurable-lists')) {
            total += await getStorageClient(shared_1.configurableListEntityName).count({});
            if (cancelRef.cancel) {
                return;
            }
        }
        if (features.includes('classifiers') && classifiers) {
            for (const { entityName } of classifiers) {
                total += await getStorageClient(entityName).count({});
                if (cancelRef.cancel) {
                    return;
                }
            }
        }
        status = 'exporting';
        let label = '';
        progressCallback({ status, total, count });
        if (features.includes('editable-settings')) {
            label = t('configurationTransfer.featuresEnum.editable-settings');
            progressCallback({ status, total, count, label });
            result['editable-settings'] = (await getAllData({
                settingFunctionClient: getFunctionClient(),
                storageClient: getStorageClient(shared_3.settingEntityName),
                cancelRef,
                countCallback: () => {
                    progressCallback({ status, total, count: ++count, label });
                },
            })).map(({ name, value }) => ({ name, value }));
            if (cancelRef.cancel) {
                return;
            }
            label = '';
        }
        if (features.includes('editable-pages')) {
            label = t('configurationTransfer.featuresEnum.editable-pages');
            progressCallback({ status, total, count, label });
            result['editable-pages'] = await getAllData({
                storageClient: getStorageClient(shared_2.editablePageEntityName),
                cancelRef,
                countCallback: () => {
                    progressCallback({ status, total, count: ++count, label });
                },
            });
            if (cancelRef.cancel) {
                return;
            }
            label = '';
        }
        if (features.includes('configurable-lists')) {
            label = t('configurationTransfer.featuresEnum.configurable-lists');
            progressCallback({ status, total, count, label });
            result['configurable-lists'] = await getAllData({
                storageClient: getStorageClient(shared_1.configurableListEntityName),
                cancelRef,
                countCallback: () => {
                    progressCallback({ status, total, count: ++count, label });
                },
            });
            if (cancelRef.cancel) {
                return;
            }
            label = '';
        }
        if (features.includes('classifiers') && classifiers) {
            const classifiersResult = {};
            for (const { entityName, label: classifierLabel, onExportMapData } of classifiers) {
                label = t('configurationTransfer.classifier') + ' ' + classifierLabel;
                progressCallback({ status, total, count, label });
                classifiersResult[entityName] = await getAllData({
                    storageClient: getStorageClient(entityName),
                    cancelRef,
                    countCallback: () => {
                        progressCallback({ status, total, count: ++count, label });
                    },
                    onExportMapData: onExportMapData,
                });
                if (cancelRef.cancel) {
                    return;
                }
                label = '';
            }
            result['classifiers'] = classifiersResult;
        }
    })()
        .then(() => {
        status = cancelRef.cancel ? 'canceled' : 'done';
        progressCallback({ status, total, count, result: status === 'done' ? JSON.stringify(result) : undefined });
    })
        .catch((error) => {
        status = 'error';
        progressCallback({ status, total, count, error });
    });
    return {
        cancel: () => {
            status = 'canceling';
            progressCallback({ status, total, count });
            cancelRef.cancel = true;
        },
    };
}
async function getAllData({ settingFunctionClient, storageClient, cancelRef, countCallback, onExportMapData, }) {
    const ids = settingFunctionClient
        ? (await settingFunctionClient.executeFunction({
            functionName: 'getSettingsByGroup',
            params: { filter: [{ column: 'readOnly', op: '=', value: false }] },
        })).result.rows.map((row) => row.id)
        : (await storageClient.list({})).rows.map((row) => row.id);
    const result = [];
    if (cancelRef.cancel) {
        return result;
    }
    for (const id of ids) {
        const response = await storageClient.get(id);
        let data = response.data;
        if (onExportMapData) {
            if (cancelRef.cancel) {
                return result;
            }
            data = await onExportMapData(response);
        }
        result.push(data);
        countCallback();
        if (cancelRef.cancel) {
            return result;
        }
    }
    return result;
}
